// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ZG-z","modalContent":"_G-z","header":"aH-z","close":"bH-z"};